var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcUnion = function SvgIcUnion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.563.418a1.428 1.428 0 1 1 2.019 2.02L11.019 9l6.563 6.563a1.428 1.428 0 1 1-2.02 2.019L9 11.019l-6.563 6.563a1.428 1.428 0 0 1-2.019-2.02L6.981 9 .418 2.437A1.428 1.428 0 0 1 2.438.418L9 6.981 15.563.418Z",
    fill: "#E7424C"
  })));
};
export default SvgIcUnion;